export default function ($http) {
    return function (vehicleId, keeperId) {
        return $http.get(`api/vehicles/${ vehicleId }/keepers/${ keeperId }`)
                    .then(x => x.data.result);
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/keepers/getKeeperDetails.js